import constants from '@common/constants';
import { useUserStore } from '@common/store/useUserStore';
import { removeCookie } from '@libs/utils/helpers/getSafeCookies';
import safestorage from '@libs/utils/helpers/getSafeStorage';

import useAuthenticatedUser from '@libs/acp/hooks/useAuthenticatedUser';

import { useSortingHat } from '@libs/creditkit';
import { useAgreementsListQuery } from '@libs/renegkit/queries/agreements';

export default function useAuth() {
	const { acpLogout } = useAuthenticatedUser();
  const { removeAgreementsCache } = useAgreementsListQuery(false);

  const [resetSimulatedDebts] = useUserStore((state) => [
    state.resetSimulatedDebts,
  ]);

  const { resetSHContext } = useSortingHat({});

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  function addLegacyUser(_res: any) {
    // TODO acp-migration: writes removidos (Task 12). Login hidrata via AuthenticationProvider → addAuthenticatedUser.
  }

  function logOut() {
    acpLogout();

    resetSHContext();
    resetSimulatedDebts();
    // TODO acp-migration: cleanup one-shot para usuários com cookies do build anterior.
    // Remover estes calls após 1 release (data: ~2026-06-20).
    removeCookie(constants.legacyAuth.TOKEN);
    removeCookie("SUBJECT_DEV");
    removeCookie("SUBJECT");
    removeCookie(constants.legacyAuth.X_AUTH_TOKEN);
    removeCookie(constants.legacyAuth.X_USER_CONTEXT);
    removeCookie(constants.loans.canAccessNoverdeIntegratedFlow);
    removeCookie(constants.loans.canAccessSimplicIntegratedFlow);
    removeCookie(constants.loans.canAccessSupersimIntegratedFlow);
    removeCookie('KEEP_SESSION');
    removeCookie('ATENDE_TOKEN');
    removeCookie('ATENDE_SIGNUP');
    sessionStorage.clear();
    // endSession();
    localStorage.removeItem(constants.debts.SORTING_DEBTS_RES);
    removeAgreementsCache();

    const preserveKeys = ['ss_incoming_params', 'ss_webReferrer'] as const;
    const preserved = preserveKeys.reduce<Record<string, string | null>>((acc, key) => {
      acc[key] = localStorage.getItem(key);
      return acc;
    }, {});

    sessionStorage.removeItem('ads_kv');
    localStorage.clear();
    safestorage.clear().then(() => {
      setTimeout(() => {
        Object.entries(preserved).forEach(([key, value]) => {
          if (value !== null) localStorage.setItem(key, value);
        });
      }, 100);
    });
  }

  return {
    logOut,
    addLegacyUser,
  };
}
